
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-100 z-50">
      <nav className="px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Elite Rolling
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className="text-gray-700 hover:text-gray-900 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Process
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-gray-900 text-white px-6 py-2 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Event
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-gray-900 font-medium text-left whitespace-nowrap cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-gray-900 font-medium text-left whitespace-nowrap cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('process')}
                className="text-gray-700 hover:text-gray-900 font-medium text-left whitespace-nowrap cursor-pointer"
              >
                Process
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-gray-900 text-white px-6 py-2 rounded-full hover:bg-gray-800 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Book Event
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
